module.exports = __webpack_public_path__ + "img/1F3AC.a77133bd.svg";